export const APP_ROUTES = {
  LOGIN: '/login',
  HOME: '/',

  // Cliente
  CLIENTE_CADASTRO: '/cliente/cadastro',
  CLIENTE_VISUALIZAR: '/cliente/visualizar',
  CLIENTE_GERAL_EDITAR: '/cliente/geral/:id',

  // Empresa
  EMPRESA_CADASTRO: '/empresa/cadastro',
  EMPRESA_VISUALIZAR: '/empresa/visualizar',
  EMPRESA_EDITAR: '/empresa/editar/:id',

  // Banco
  BANCO_VISUALIZAR: '/banco/visualizar',

  // Usuário
  USUARIO_CADASTRO: '/usuario/cadastro',
  USUARIO_VISUALIZAR: '/usuario/visualizar',
  USUARIO_EDITAR: '/usuario/editar/:id',

  // Comunicação
  EQUIPAMENTO_VISUALIZAR: '/equipamento/visualizar',

  // Relatórios
  RELATORIO_AUDITORIA: '/relatorio/auditoria',

  //Desenvolvimento
  DESENVOLVIMENTO_CHAVES: '/desenvolvimento/chaves',
  DESENVOLVIMENTO_CHAVES_CADASTRO: '/desenvolvimento/chaves/cadastro',
  DESENVOLVIMENTO_CHAVES_EDITAR: '/desenvolvimento/chaves/:id',
  DESENVOLVIMENTO_MIGRATION: '/desenvolvimento/migration',
  DESENVOLVIMENTO_LOGS: '/desenvolvimento/logs',


};

// Atualiza getEditarPath para aceitar params opcionais e montar query string
export const getEditarPath = (path, id, params) => {
  let url = path.replace(':id', id);
  if (params && typeof params === 'object' && Object.keys(params).length > 0) {
    const query = Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    url += `?${query}`;
  }
  return url;
};
